<template>
    <span>
        <ul class="preview_photo_wrap" v-if="typeof item.values === 'object' && item.values.length > 0">
            <li v-for="(value, index) in item.values"
                class="pointer" v-bind:class="item.class" v-bind:key="value.seq"
                @click="openSlider(item.sliderId, index)">
                <img
                    :src="value.thumbnailImageUrl"
                    :width="item.width"
                    :height="item.height"
                    @error="(e)=>e.target.src = '/images/ic/control/check-box-off.svg'"
                    alt=""
                />
            </li>
        </ul>
        <div v-else>
          {{ this.$t('alert.no_image') }}
        </div>
        <ImageSlider
            ref="slider"
            :openProps="open"
            :itemProps="item"
            :clickedIndexProps="clickedIndex"
            :windowProps="item.window"
            @closeSlider="closeSlider"
        />
    </span>
</template>
<script>
import ImageSlider from '@/components/modal/imageSlider';

export default {
  name: 'imagePreview',
  props: ['item'],
  components: {
    ImageSlider,
  },
  data() {
    return {
      open: false,
      sliderId: 0, // 같은 슬라이더를 여러개 열지 않게 하기 위함
      clickedIndex: 0
    }
  },
  watch: {
    item() {
      // 사용자가 다른 스케쥴을 클릭했을 경우 기존에 창이 열려있다면, index 를 초기화
      this.clickedIndex = 0;
    }
  },
  methods: {
    openSlider(sliderId, index) {
      if (!this.open) {
        this.open = true;
        this.sliderId = sliderId;
        this.clickedIndex = index;
      } else {
        this.$refs.slider.focusPortal(index);
        window.setTimeout(() => {
          this.openSlider(sliderId, index);
        }, 0);
      }
    },
    closeSlider() {
      this.open = false;
      this.sliderId = 0;
    }
  },
  beforeDestroy() {
    this.$refs.slider.closePortal();
  }
}
</script>
<style lang="scss">
    .preview_photo_wrap {
        display: flex;
        flex-wrap: wrap;

        li {
            margin-right: 8px;
            margin-bottom: 8px;
            border: 1px solid var(--grey20);
        }
    }
</style>